// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__certificate-wrapper[data-v-25e1ccaa]{max-width:910px}.card__certificate[data-v-25e1ccaa]{height:300px;border-radius:10.4px;background:#eeeff8}.text__publish-time[data-v-25e1ccaa]{color:rgba(7,9,25,.5)}", ""]);
// Exports
module.exports = exports;
